<template>
  <div class="row">
    <div class="col-12">
      <card class="custom-shadow-card-header card-gis-filter">
        <el-collapse v-model="activeName" @change="handleCollapse">
          <el-collapse-item :title="titleFilter" name="1">
            <div class="row p-3">
              <div class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-3">
                <label>{{ $t('common_words.farm') }} *</label>
                <br />
                <el-select
                  @change="changeByFarm"
                  @clear="unsynchronizedReportForm.farms = []"
                  clearable
                  multiple
                  :multiple-limit="1"
                  v-bind:collapse-tags="true"
                  filterable
                  class="select-primary custom-width-select required-farm shadow-sm"
                  size="large"
                  v-model="unsynchronizedReportForm.farms"
                  :placeholder="`${$t('common_words.select')}...`"
                >
                  <el-option
                    v-for="(option, index) in farms"
                    class="select-primary"
                    :value="option.id"
                    :label="option.name"
                    :key="index + option.id"
                  ></el-option>
                </el-select>
              </div>
              <div class="col-12 col-sm-12 col-md-2 col-lg-2">
                <label>{{ $t('production.scale_type') }} * </label>
                <br />
                <el-select
                  @change="changeByType"
                  filterable
                  @clear="unsynchronizedReportForm.typeScale = null"
                  clearable
                  class="select-primary custom-width-select required-typeScale shadow-sm"
                  size="large"
                  v-model="unsynchronizedReportForm.typeScale"
                  :placeholder="`${$t('common_words.select')}...`"
                >
                  <el-option
                    v-for="option in optionsScale"
                    class="select-primary"
                    :value="option.value"
                    :label="option.label"
                    :key="option.value"
                  ></el-option>
                </el-select>
              </div>
              <div class="col-12 col-sm-12 col-md-2 col-lg-2">
                <label>{{ $t('common_words.analyze_by') }}</label>
                <br />
                <el-select
                  @change="changeByInterval"
                  filterable
                  @clear="unsynchronizedReportForm.bySel = null"
                  clearable
                  class="select-primary custom-width-select required-farm shadow-sm"
                  size="large"
                  v-model="unsynchronizedReportForm.bySel"
                  :placeholder="`${$t('common_words.select')}...`"
                >
                  <el-option
                    v-for="option in optionsInterval"
                    class="select-primary"
                    :value="option.value"
                    :label="option.label"
                    :key="option.value"
                  ></el-option>
                </el-select>
              </div>
              <div
                class="col-12 col-sm-8 col-md-4 col-lg-4 col-xl-3"
                v-if="
                  unsynchronizedReportForm.bySel &&
                  unsynchronizedReportForm.bySel != 'week' &&
                  unsynchronizedReportForm.bySel != 'year'
                "
              >
                <label>{{ $t('common_words.calendar') }}</label>
                <br />
                <el-date-picker
                  v-if="renderComponent"
                  @change="changeByFarm"
                  v-model="rangeDate"
                  clearable
                  class="shadow-sm required-year"
                  v-bind:type="typedatepicket"
                  :picker-options="pickerOptions"
                  range-separator="-"
                  :placeholder="`${$t('common_words.select2')}...`"
                  :start-placeholder="$t('common_words.initial_date')"
                  :end-placeholder="$t('common_words.final_date')"
                >
                </el-date-picker>
              </div>
              <div
                class="col-6 col-sm-3 col-md-2 col-lg-2 col-xl-1"
                style="padding-right: 0; padding-top: 32px"
                v-if="
                  unsynchronizedReportForm.bySel == 'week' ||
                  unsynchronizedReportForm.bySel == 'year'
                "
              >
                <el-select
                  @change="changeByFarm"
                  clearable
                  @clear="unsynchronizedReportForm.week_sel_init = null"
                  filterable
                  class="select-primary custom-width-select required-year shadow-sm"
                  size="large"
                  v-model="unsynchronizedReportForm.year_sel_init"
                >
                  <el-option
                    v-for="(option, index) in years"
                    class="select-primary"
                    :value="index"
                    :label="index"
                    :key="index * 100 + 1"
                  ></el-option>
                </el-select>
              </div>
              <div
                class="col-6 col-sm-3 col-md-2 col-lg-2 col-xl-1"
                style="padding-top: 32px"
                v-if="
                  unsynchronizedReportForm.bySel == 'week' &&
                  unsynchronizedReportForm.year_sel_init
                "
              >
                <el-select
                  @change="changeByFarm"
                  clearable
                  filterable
                  class="select-primary custom-width-select required-week shadow-sm"
                  size="large"
                  v-model="unsynchronizedReportForm.week_sel_init"
                >
                  <el-option
                    v-for="(week, index) in years[
                      unsynchronizedReportForm.year_sel_init
                    ]"
                    class="select-primary"
                    :value="week"
                    :label="week"
                    :key="index * 200 + 2"
                  ></el-option>
                </el-select>
              </div>
              <div
                class="col-6 col-sm-3 col-md-2 col-lg-2 col-xl-1"
                style="padding-right: 0; padding-top: 32px"
                v-if="
                  unsynchronizedReportForm.bySel == 'week' ||
                  unsynchronizedReportForm.bySel == 'year'
                "
              >
                <el-select
                  @change="changeByFarm"
                  clearable
                  @clear="unsynchronizedReportForm.week_sel_end = null"
                  filterable
                  class="select-primary custom-width-select required-year shadow-sm"
                  size="large"
                  v-model="unsynchronizedReportForm.year_sel_end"
                >
                  <el-option
                    v-for="(option, index) in years"
                    class="select-primary"
                    :value="index"
                    :label="index"
                    :key="index * 300 + 4"
                  ></el-option>
                </el-select>
              </div>
              <div
                class="col-6 col-sm-3 col-md-2 col-lg-2 col-xl-1"
                style="padding-top: 32px"
                v-if="
                  unsynchronizedReportForm.bySel == 'week' &&
                  unsynchronizedReportForm.year_sel_end
                "
              >
                <el-select
                  @change="changeByFarm"
                  clearable
                  filterable
                  class="select-primary custom-width-select required-week shadow-sm"
                  size="large"
                  v-model="unsynchronizedReportForm.week_sel_end"
                >
                  <el-option
                    v-for="(week, index) in years[
                      unsynchronizedReportForm.year_sel_end
                    ]"
                    class="select-primary"
                    :value="week"
                    :label="week"
                    :key="index * 400 + 6"
                  ></el-option>
                </el-select>
              </div>
              <div class="col-12 col-md-4 col-xl-2">
                <label class="label-primary" style="color: transparent">{{
                  $t('common_words.filter')
                }}</label
                ><br />
                <l-button wide type="info" class="btn-filter" @click="validate">
                  {{ $t('common_words.filter') }}
                </l-button>
              </div>
            </div>
          </el-collapse-item>
        </el-collapse>
        <template v-if="unsynchronizedReport">
          <div v-if="isIndex()">
            <div
              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
              <el-select
                clearable
                @clear="pagination.perPage = 10"
                filterable
                class="select-default mb-3 shadow-sm"
                style="width: 200px"
                v-model="pagination.perPage"
                :placeholder="$t('common_words.per_page')"
              >
                <el-option
                  class="select-default"
                  v-for="item in pagination.perPageOptions"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>
              <el-input
                clearable
                class="mb-3 shadow-sm"
                style="width: 200px"
                :placeholder="$t('common_words.search_records')"
                v-model="searchQuery"
                aria-controls="datatables"
              />
            </div>
            <div class="col-sm-12">
              <el-table
                stripe
                :default-sort="{ prop: 'name', order: 'descending' }"
                style="width: 100%"
                :data="queriedData"
                :border="true"
                v-if="unsynchronizedReportForm.typeScale == 0"
                :cell-style="handlecellstyle"
              >
                <el-table-column
                  v-for="column in tableColumns"
                  :key="column.label"
                  :min-width="column.minWidth"
                  :prop="column.prop"
                  :label="column.label"
                  fixed
                >
                </el-table-column>
                <el-table-column
                  :min-width="120"
                  :label="$t('common_words.farm')"
                >
                  <template slot-scope="props">
                    <el-select
                      clearable
                      filterable
                      class="select-primary custom-width-select required-farm shadow-sm"
                      size="large"
                      v-model="queriedData[props.$index].code_finca"
                      :placeholder="`${$t('common_words.select')}...`"
                    >
                      <el-option
                        v-for="(option, index) in farms2"
                        class="select-primary"
                        :value="option.code"
                        :label="option.name"
                        :key="index + option.id"
                      ></el-option>
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column
                  :min-width="80"
                  :label="`${$t('production.weight')} ${' + weightUnit + '}`"
                >
                  <template slot-scope="props">
                    {{ queriedData[props.$index].peso }}
                  </template>
                </el-table-column>
                <el-table-column
                  :min-width="80"
                  :label="$t('common_words.age')"
                >
                  <template slot-scope="props">
                    {{ queriedData[props.$index].edad }}
                  </template>
                </el-table-column>
                <el-table-column
                  :min-width="100"
                  :label="$t('production.ribbon')"
                >
                  <template slot-scope="props">
                    <div class="text">
                      <span
                        v-if="ribbons[queriedData[props.$index].cinta]"
                        :style="
                          'color:' +
                          ribbons[queriedData[props.$index].cinta]['t_color'] +
                          ' !important'
                        "
                      >
                        {{
                          capitalizeFirstLetter(
                            ribbons[queriedData[props.$index].cinta][
                              'name'
                            ].toLowerCase()
                          )
                        }}
                      </span>
                      <span v-else>{{ queriedData[props.$index].cinta }}</span>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  :min-width="120"
                  :label="$t('production.crew_division')"
                >
                  <template slot-scope="props">
                    <el-input
                      class="shadow-sm"
                      style="width: 100px !important; border: none !important"
                      v-model="queriedData[props.$index].cuadrilla"
                    >
                    </el-input>
                  </template>
                </el-table-column>
                <el-table-column
                  :min-width="120"
                  :label="$t('common_words.allotment')"
                >
                  <template slot-scope="props">
                    <el-select
                      clearable
                      filterable
                      class="select-primary custom-width-select required-farm shadow-sm"
                      size="large"
                      v-model="queriedData[props.$index].lote"
                      :placeholder="`${$t('common_words.select')}...`"
                    >
                      <el-option
                        v-for="(option, index) in lots[
                          queriedData[props.$index].code_finca
                        ]"
                        class="select-primary"
                        :value="option.name"
                        :label="option.name"
                        :key="index + option.id"
                      ></el-option>
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column
                  :min-width="120"
                  :label="$t('production.denegation_type')"
                >
                  <template slot-scope="props">
                    <el-select
                      clearable
                      filterable
                      class="select-primary custom-width-select required-farm shadow-sm"
                      size="large"
                      v-model="queriedData[props.$index].tipo_recusado_id"
                      :placeholder="`${$t('common_words.select')}...`"
                    >
                      <el-option
                        v-for="(option, index) in causesRejected"
                        class="select-primary"
                        :value="option.id"
                        :label="option.name"
                        :key="index + option.id"
                      ></el-option>
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column
                  :min-width="120"
                  :label="$t('production.hands_numbers')"
                >
                  <template slot-scope="props">
                    <el-input
                      class="shadow-sm"
                      style="width: 100px !important; border: none !important"
                      v-model="queriedData[props.$index].numero_de_manos"
                    >
                    </el-input>
                  </template>
                </el-table-column>
                <el-table-column
                  :min-width="120"
                  :label="$t('production.calibration_second_hand_unit')"
                >
                  <template slot-scope="props">
                    <el-input
                      class="shadow-sm"
                      style="width: 100px !important; border: none !important"
                      v-model="
                        queriedData[props.$index].calibracion_segunda_mano
                      "
                    >
                    </el-input>
                  </template>
                </el-table-column>
                <el-table-column
                  :min-width="120"
                  :label="$t('production.calibration_last_hand_unit')"
                >
                  <template slot-scope="props">
                    <el-input
                      class="shadow-sm"
                      style="width: 100px !important; border: none !important"
                      v-model="
                        queriedData[props.$index].calibracion_ultimo_mano
                      "
                    >
                    </el-input>
                  </template>
                </el-table-column>
                <el-table-column
                  :min-width="120"
                  :label="$t('production.hand_second_large_unit')"
                >
                  <template slot-scope="props">
                    <el-input
                      class="shadow-sm"
                      style="width: 100px !important; border: none !important"
                      v-model="queriedData[props.$index].largo_segunda_mano"
                    >
                    </el-input>
                  </template>
                </el-table-column>
                <el-table-column
                  :min-width="120"
                  :label="$t('production.hand_second_last_unit')"
                >
                  <template slot-scope="props">
                    <el-input
                      class="shadow-sm"
                      style="width: 100px !important; border: none !important"
                      v-model="queriedData[props.$index].largo_ultima_mano"
                    >
                    </el-input>
                  </template>
                </el-table-column>
                <el-table-column
                  :min-width="100"
                  fixed="right"
                  :label="$t('common_words.actions')"
                >
                  <template slot-scope="props">
                    <a
                      v-if="isDelete()"
                      v-tooltip.top-center="$t('common_words.erase')"
                      class="btn-danger btn-simple btn-link"
                      @click="handleDelete(props.$index, props.row)"
                      ><em class="fa fa-times"></em
                    ></a>
                    <a
                      v-if="isUpdate()"
                      v-tooltip.top-center="$t('common_words.save')"
                      class="btn-success btn-simple btn-link"
                      @click="handleEdit(props.$index, props.row)"
                      ><em class="fa fa-save"></em
                    ></a>
                  </template>
                </el-table-column>
              </el-table>
              <el-table
                stripe
                :default-sort="{ prop: 'name', order: 'descending' }"
                style="width: 100%"
                :data="queriedData"
                :border="true"
                v-else-if="unsynchronizedReportForm.typeScale == 2"
              >
                <el-table-column
                  v-for="column in tableColumns2"
                  :key="column.label"
                  :min-width="column.minWidth"
                  :prop="column.prop"
                  :label="column.label"
                  fixed
                >
                </el-table-column>
                <el-table-column
                  :min-width="100"
                  :label="$t('common_words.farm')"
                >
                  <template slot-scope="props">
                    <el-select
                      clearable
                      filterable
                      class="select-primary custom-width-select required-farm shadow-sm"
                      size="large"
                      v-model="queriedData[props.$index].code_finca"
                      :placeholder="`${$t('common_words.select')}...`"
                    >
                      <el-option
                        v-for="(option, index) in farms2"
                        class="select-primary"
                        :value="option.code"
                        :label="option.name"
                        :key="index + option.id"
                      ></el-option>
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column
                  :min-width="80"
                  :label="`${$t('production.weight')} ${' + weightUnit + '}`"
                >
                  <template slot-scope="props">
                    {{ queriedData[props.$index].peso }}
                  </template>
                </el-table-column>
                <el-table-column :min-width="150" :label="$t('production.box')">
                  <template slot-scope="props">
                    <el-select
                      clearable
                      filterable
                      class="select-primary custom-width-select required-farm shadow-sm"
                      size="large"
                      v-model="queriedData[props.$index].codigo"
                      :placeholder="`${$t('common_words.select')}...`"
                    >
                      <el-option
                        v-for="(option, index) in boxes"
                        class="select-primary"
                        :value="option.code"
                        :label="option.name"
                        :key="index + option.id"
                      ></el-option>
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column
                  :min-width="80"
                  fixed="right"
                  :label="$t('common_words.actions')"
                >
                  <template slot-scope="props">
                    <a
                      v-if="isDelete()"
                      v-tooltip.top-center="$t('common_words.erase')"
                      class="btn-danger btn-simple btn-link"
                      @click="handleDelete(props.$index, props.row)"
                      ><em class="fa fa-times"></em
                    ></a>
                    <a
                      v-if="isUpdate()"
                      v-tooltip.top-center="$t('common_words.save')"
                      class="btn-success btn-simple btn-link"
                      @click="handleEdit(props.$index, props.row)"
                      ><em class="fa fa-save"></em
                    ></a>
                  </template>
                </el-table-column>
              </el-table>
              <el-table
                stripe
                :default-sort="{ prop: 'name', order: 'descending' }"
                style="width: 100%"
                :data="queriedData"
                border
                v-else
              >
                <el-table-column
                  v-for="column in tableColumns3"
                  :key="column.label"
                  :min-width="column.minWidth"
                  :prop="column.prop"
                  :label="column.label"
                  fixed
                >
                </el-table-column>
                <el-table-column
                  :min-width="100"
                  :label="$t('common_words.farm')"
                >
                  <template slot-scope="props">
                    <el-select
                      clearable
                      filterable
                      class="select-primary custom-width-select required-farm shadow-sm"
                      size="large"
                      v-model="queriedData[props.$index].code_finca"
                      :placeholder="`${$t('common_words.select')}...`"
                    >
                      <el-option
                        v-for="(option, index) in farms2"
                        class="select-primary"
                        :value="option.code"
                        :label="option.name"
                        :key="index + option.id"
                      ></el-option>
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column
                  :min-width="80"
                  :label="`${$t('production.weight')} ${' + weightUnit + '}`"
                >
                  <template slot-scope="props">
                    {{ queriedData[props.$index].peso }}
                  </template>
                </el-table-column>
                <el-table-column
                  :min-width="100"
                  fixed="right"
                  :label="$t('common_words.actions')"
                >
                  <template slot-scope="props">
                    <a
                      v-if="isDelete()"
                      v-tooltip.top-center="$t('common_words.erase')"
                      class="btn-danger btn-simple btn-link"
                      @click="handleDelete(props.$index, props.row)"
                      ><em class="fa fa-times"></em
                    ></a>
                    <a
                      v-if="isUpdate()"
                      v-tooltip.top-center="$t('common_words.save')"
                      class="btn-success btn-simple btn-link"
                      @click="handleEdit(props.$index, props.row)"
                      ><em class="fa fa-save"></em
                    ></a>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
          <div v-else>
            <br />
            <h5 class="text-muted text-center">
              {{ $t('common_words.no_permissions') }}
            </h5>
          </div>
          <div
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <div class="">
              <p class="card-category">
                {{ $t('table2.showing') }} {{ from + 1 }} {{ $t('table2.a') }}
                {{ to }} {{ $t('table2.of') }} {{ total }}
                {{ $t('table2.entries') }}
              </p>
            </div>
            <l-pagination
              class="pagination-no-border"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="pagination.total"
              pageFirst="false"
              pageLast="false"
            >
            </l-pagination>
          </div>
          <br />
          <center v-if="this.tableData.length > 1000">
            <div class="row">
              <div class="col" v-if="isExcel()">
                <button
                  class="btn custom-btn-success custom-shadow-btn"
                  @click="exportExcel"
                >
                  <em class="fa fa-file-excel-o"></em>
                  {{ $t('common_words.export_to_excel') }}
                </button>
              </div>
            </div>
          </center>
          <div
            class="row"
            style="padding-right: 13px; padding-left: 13px"
            v-else
          >
            <div class="col-4" v-if="isUpdate()">
              <div class="text-right">
                <button
                  class="btn custom-btn-success custom-shadow-btn"
                  @click="savedData"
                >
                  <em class="fa fa-save"></em>
                  {{ $t('common_words.save') }}
                </button>
              </div>
            </div>
            <div class="col-4" v-if="isPDF()">
              <div class="text-center">
                <button
                  class="btn btn-danger custom-shadow-btn"
                  @click="exportPDF"
                >
                  <em class="fa fa-file-pdf-o"></em>
                  {{ $t('common_words.export_to_pdf') }}
                </button>
              </div>
            </div>
            <div class="col-4" v-if="isExcel()">
              <div class="text-left">
                <button
                  class="btn custom-btn-success custom-shadow-btn"
                  @click="exportExcel"
                >
                  <em class="fa fa-file-excel-o"></em>
                  {{ $t('common_words.export_to_excel') }}
                </button>
              </div>
            </div>
          </div>
        </template>
      </card>
    </div>
  </div>
</template>
<script>
import moment from 'moment';
import SweetAlert from 'src/class/Alerts';
import mixinMasters from 'src/util/mixinMasters';
import MixinPermissions from 'src/util/mixinPermissions';
import MixinDatePicker from 'src/util/mixinDatePicker';
import { MixinExport } from 'src/mixins/mixin-export';
import { Axios } from 'src/class/Axios.js';
import MixinMenu from 'src/util/mixinMenu';
import configTable from './UnsynchronizedTable';
import configTable2 from './UnsynchronizedTable2';
import configTable3 from './UnsynchronizedTable3';
import { Pagination as LPagination } from 'src/components/index';
import Fuse from 'fuse.js';
import i18n from 'src/i18n';

export default {
  components: {
    LPagination,
  },
  computed: {
    ...configTable().Search,
    ...configTable2().Search,
    ...configTable3().Search,

    optionsInterval() {
      return {
        0: { label: i18n.t('common_words.day'), value: 'daterange' },
        1: { label: i18n.t('common_words.week'), value: 'week' },
        2: { label: i18n.t('common_words.month'), value: 'monthrange' },
        3: { label: i18n.t('common_words.year'), value: 'year' },
      };
    },
    optionsScale() {
      return {
        0: { label: i18n.t('production.cluster_fruit'), value: 0 },
        1: { label: i18n.t('production.box'), value: 2 },
        2: { label: i18n.t('production.cluster'), value: 1 },
        3: { label: i18n.t('production.tray'), value: 4 },
        4: { label: i18n.t('production.rejected'), value: 5 },
      };
    },

    titleFilter() {
      if (this.valueCollapse) {
        return this.valueCollapse.length === 1
          ? this.$i18n.t('uti.mixinFilter.hideFilters')
          : this.$i18n.t('uti.mixinFilter.showFilters');
      }
    },
  },

  data() {
    return {
      unsynchronizedReportForm: {
        bySel: null,
      },
      activeName: '1',
      typedatepicket: 'daterange',
      valueCollapse: null,
      reports: [],
      interval: 'Semana',
      years: [],
      farms: [{ id: 0, name: 'Otras' }],
      farms2: [],
      unsynchronizedReport: false,
      titleCard: '',
      pagination: {},
      tableColumns: [],
      tableColumns2: [],
      tableColumns3: [],
      boxes: [],
      ribbons: [],
      lots: [],
      listBoxes: [],
      causesRejected: [],
      editForm: [],
      update: false,
      weightUnit: 'Kg',
      originalTableData: [],
    };
  },

  mixins: [
    mixinMasters,
    MixinPermissions,
    MixinDatePicker,
    MixinExport,
    MixinMenu,
  ],

  watch: {
    '$i18n.locale': [
      'setupTable',
      'setupTable2',
      'setupTable3',
      'forceRerender',
    ],
  },

  methods: {
    changeByInterval() {
      this.unsynchronizedReport = false;
      sessionStorage.removeItem('editForm');
      for (
        let index = 0;
        index < Object.values(this.optionsInterval).length;
        index++
      ) {
        const element = Object.values(this.optionsInterval)[index];
        if (element.label == this.unsynchronizedReportForm.bySel) {
          this.typedatepicket = element.value;
          break;
        }
      }
    },

    changeByType() {
      sessionStorage.removeItem('editForm');
      this.unsynchronizedReport = false;
      this.pagination.currentPage = 1;
      this.pagination.currentPage = 1;
      this.pagination.currentPage = 1;
      this.pagination.perPage = 10;
      this.pagination.perPage = 10;
      this.pagination.perPage = 10;
      if (this.unsynchronizedReportForm.typeScale == 1) this.weightUnit = 'lb';
      else this.weightUnit = 'kg';
    },

    changeByFarm() {
      sessionStorage.removeItem('editForm');
      this.pagination.currentPage = 1;
      this.pagination.currentPage = 1;
      this.pagination.currentPage = 1;
      this.pagination.perPage = 10;
      this.pagination.perPage = 10;
      this.pagination.perPage = 10;
    },

    handleCollapse(val) {
      this.valueCollapse = val;
    },

    handleEdit(index, row) {
      if (this.unsynchronizedReportForm.typeScale == 2)
        row.tipo_caja_id = this.listBoxes[row.codigo];
      row.typeScale = this.unsynchronizedReportForm.typeScale;
      row.index = index;
      this.updateData(row);
    },

    handleDelete(index, row) {
      SweetAlert.delete(i18n.t('common_words.the_record') + row.id).then(
        (result) => {
          if (result.value) this.deleteModule(row);
        }
      );
    },

    handlecellstyle({ row, columnIndex }) {
      if (row.cinta && columnIndex == 6 && this.ribbons[row.cinta]) {
        return 'background-color: ' + this.ribbons[row.cinta]['b_color'];
      }
    },

    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },

    validate() {
      this.unsynchronizedReportForm.calendar_sel = this.rangeDate;
      if (
        this.unsynchronizedReportForm.farms == null ||
        this.unsynchronizedReportForm.farms.length == 0
      ) {
        return this.validationInputsRequired('farm');
      } else if (
        this.unsynchronizedReportForm.typeScale == null ||
        this.unsynchronizedReportForm.typeScale.length == 0
      ) {
        return this.validationInputsRequired('typeScale');
      } else if (
        (this.unsynchronizedReportForm.bySel == 'year' &&
          (this.unsynchronizedReportForm.year_sel_init == null ||
            this.unsynchronizedReportForm.year_sel_end == null)) ||
        (this.unsynchronizedReportForm.bySel == 'week' &&
          this.isYearSelRequired() &&
          this.unsynchronizedReportForm.year_sel_init == null)
      ) {
        return this.validationInputsRequired('year');
      } else if (
        this.isWeekSekRequired() &&
        this.unsynchronizedReportForm.week_sel_init == null &&
        this.unsynchronizedReportForm.bySel == 'week'
      ) {
        return this.validationInputsRequired('week');
      } else if (
        this.isYearSelRequired() &&
        this.unsynchronizedReportForm.year_sel_end == null &&
        this.unsynchronizedReportForm.bySel == 'week'
      ) {
        return this.validationInputsRequired('year');
      } else if (
        this.isWeekSekRequired() &&
        this.unsynchronizedReportForm.week_sel_end == null &&
        this.unsynchronizedReportForm.bySel == 'week'
      ) {
        return this.validationInputsRequired('week');
      } else if (this.unsynchronizedReportForm.calendar_sel == null) {
        SweetAlert.warning(i18n.t('common_words.no_associated_calendars'));
      } else {
        this.loadUnsynchronizedReport();
      }
    },

    loadData() {
      let data = {
        farms: this.unsynchronizedReportForm.farms,
        init:
          parseInt(this.unsynchronizedReportForm.year_sel_init) * 100 +
          parseInt(this.unsynchronizedReportForm.week_sel_init),
        end:
          parseInt(this.unsynchronizedReportForm.year_sel_end) * 100 +
          parseInt(this.unsynchronizedReportForm.week_sel_end),
        bySel: this.unsynchronizedReportForm.bySel,
        typeScale: this.unsynchronizedReportForm.typeScale,
      };

      switch (this.unsynchronizedReportForm.bySel) {
        case 'year':
          data.init = parseInt(this.unsynchronizedReportForm.year_sel_init);
          data.end = parseInt(this.unsynchronizedReportForm.year_sel_end);
          break;
        case 'monthrange':
          data.init =
            parseInt(moment(this.rangeDate[0]).format('YYYY')) * 100 +
            parseInt(moment(this.rangeDate[0]).format('MM'));
          data.end =
            parseInt(moment(this.rangeDate[1]).format('YYYY')) * 100 +
            parseInt(moment(this.rangeDate[1]).format('MM'));
          break;
        case 'daterange':
          data.init = moment(this.rangeDate[0]).format('YYYY-MM-DD');
          data.end = moment(this.rangeDate[1]).format('YYYY-MM-DD');
          break;
      }

      return data;
    },

    savedData() {
      if (this.isCreate()) {
        this.showHideLoading(true);
        let data = this.loadData();
        data.table = this.tableData;
        data.route = 'scales/unsynchronized';
        Axios.saveMaster(data)
          .then((response) => {
            let data = this.loadData();
            data.route = 'scales/unsynchronized/reports';
            Axios.saveMaster(data)
              .then((response1) => {
                this.tableData = response1.data.table_data;
                this.modifyTable(
                  5,
                  null,
                  response.data.message,
                  null,
                  'nc-settings-90',
                  'warning',
                  null,
                  false,
                  true,
                  i18n.t('common_words.notice')
                );
              })
              .catch((error) => {
                SweetAlert.warning(error.response.data.message);
                this.showHideLoading();
              });
          })
          .catch((error) => this.showMessageErrors(error));
      } else {
        this.showMessageAccess();
      }
    },

    updateData(row) {
      if (this.isUpdate()) {
        this.showHideLoading(true);
        row.route = 'scales/unsynchronized';
        Axios.updateMaster(row)
          .then((response) => {
            this.modifyTable(1, row.id, response);
            this.tableData.splice(row.index, 1);
            this.forceRenderMenu();
          })
          .catch((error) => this.showMessageErrors(error));
      } else {
        this.showMessageAccess();
      }
    },

    deleteModule(row) {
      if (this.isDelete()) {
        this.showHideLoading(true);
        row.route = 'scales/unsynchronized/delete';
        row.typeScale = this.unsynchronizedReportForm.typeScale;
        Axios.postMasters(row)
          .then((response) => {
            this.modifyTable(2, row.id, response);
            this.forceRenderMenu();
          })
          .catch((error) => this.showMessageErrors(error));
      } else {
        this.showMessageAccess();
      }
    },

    loadUnsynchronizedReport() {
      this.showHideLoading(true);
      let data = this.loadData();
      data.route = 'scales/unsynchronized/reports';
      Axios.saveMaster(data)
        .then((response) => {
          this.tableData = response.data.table_data;
          this.numberRows = this.tableData.length;
          this.showHideLoading();
          this.update = true;
          if (this.tableData.length == 0) {
            this.unsynchronizedReport = false;
            SweetAlert.warning(i18n.t('common_words.selected_record_no_data'));
          } else {
            this.unsynchronizedReport = true;
            if (this.unsynchronizedReportForm.typeScale == 0) {
              this.fuseSearch = new Fuse(this.tableData, {
                useExtendedSearch: true,
                threshold: 0.3,
                keys: this.tableColumns.map((prop) => {
                  return prop.prop;
                }),
              });
            } else if (this.unsynchronizedReportForm.typeScale == 2) {
              this.fuseSearch = new Fuse(this.tableData, {
                useExtendedSearch: true,
                threshold: 0.3,
                keys: this.tableColumns2.map((prop) => {
                  return prop.prop;
                }),
              });
            } else {
              this.fuseSearch = new Fuse(this.tableData, {
                useExtendedSearch: true,
                threshold: 0.3,
                keys: this.tableColumns3.map((prop) => {
                  return prop.prop;
                }),
              });
            }
          }
        })
        .catch((error) => {
          SweetAlert.warning(error.response.data.message);
          this.showHideLoading();
        });
    },

    isYearSelRequired() {
      return this.interval == 'Semana';
    },

    isWeekSekRequired() {
      return this.interval == 'Semana';
    },

    exportPDF() {
      let data = this.loadData();
      data.route = 'scales/unsynchronized/reports/pdf';
      data.name_file = `${i18n.t('production.unsynchronized_data_report')}.pdf`;

      this.PDF(data, 'POST', true)
        .then(() => {
          this.showDownloadNotification();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    },

    exportExcel() {
      let data = this.loadData();
      data.route = 'scales/unsynchronized/reports/excel';
      data.name_file = `${i18n.t(
        'production.unsynchronized_data_report'
      )}.xlsx`;
      this.Excel(data, 'POST', true)
        .then(() => {
          this.showDownloadNotification();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    },
    setupTable() {
      const { Table } = configTable();
      this.tableColumns = Table.tableColumns;
      this.pagination = { ...Table.pagination };
    },
    setupTable2() {
      const { Table } = configTable2();
      this.tableColumns2 = Table.tableColumns2;
      this.pagination = { ...Table.pagination };
    },
    setupTable3() {
      const { Table } = configTable3();
      this.tableColumns2 = Table.tableColumns3;
      this.pagination = { ...Table.pagination };
    },
  },

  created() {
    if (this.isIndex()) {
      this.setupTable();
      this.setupTable2();
      this.setupTable3();
      this.showHideLoading(true);
      Axios.getMasters('scales/unsynchronized/getData')
        .then((response) => {
          this.farms = this.farms.concat(response.data['farms'].data);
          this.farms2 = response.data['farms'].data;
          this.ribbons = response.data['ribbons'];
          this.years = response.data['calendar'];
          this.boxes = response.data['boxes'].data;
          this.listBoxes = response.data['listBoxes'];
          this.lots = response.data['lots'];
          this.causesRejected = response.data['causesRejected'].data;
          this.showHideLoading();
        })
        .catch((error) => this.showMessageErrors(error));
    } else {
      this.showHideLoading();
    }

    let current = new Date();
    this.rangeDate = [
      new Date(current.setDate(current.getDate() - current.getDay())),
      new Date(current.setDate(current.getDate() - current.getDay() + 6)),
    ];
  },

  mounted() {
    this.selectedItemOnMenu('scales');
  },

  destroyed() {
    sessionStorage.removeItem('editForm');
    this.deselectedItemOnMenu('scales');
  },
};
</script>
